import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PrintDocument from '../../common/PrintDocument';

const RefundDetailsPageActionButton = ({ data }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const onClickBackButton = () => {
    return navigate('/documents?tab=refunds');
  };

  return (
    <>
      <Grid>
        {data?.irbm_response?.status === 'Valid' && (
          <PrintDocument documentType={[data.document_type]} documentId={data.document_id} />
        )}
        <Button
          id="refund-back"
          key="back"
          variant="contained"
          color="primary"
          onClick={onClickBackButton}
          className="action-button"
          sx={{ marginLeft: theme.spacing(1) }}
        >
          Back
        </Button>
      </Grid>
    </>
  );
};

export default RefundDetailsPageActionButton;
